import { useCallback, useEffect, useState } from "react";

export const useProductImageCarousel = (props) => {
  const { images, sliderRef } = props;
  const [activeItemIndex, setActiveItemIndex] = useState(0);

  const handleThumbnailClick = useCallback(
    (index) => {
      setActiveItemIndex(index);
    },
    [setActiveItemIndex]
  );

  const handlePrevious = () => {
    setActiveItemIndex((prevIndex) => {
      const index = prevIndex > 0 ? prevIndex - 1 : images.length - 1;
      sliderRef.current && sliderRef.current.slickGoTo(index);
      return index;
    });
  };

  const handleNext = () => {
    setActiveItemIndex((prevIndex) => {
      const index = prevIndex < images.length - 1 ? prevIndex + 1 : 0;
      sliderRef.current && sliderRef.current.slickGoTo(index);
      return index;
    });
  };

  useEffect(() => {
    setActiveItemIndex(0);
  }, [images, setActiveItemIndex]);

  const currentImage = images[activeItemIndex] || {};
  const altText = currentImage.label || "image-product";

  return {
    currentImage,
    activeItemIndex,
    altText,
    handleNext,
    handlePrevious,
    handleThumbnailClick,
  };
};
